import script from "./carInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./carInfo.vue?vue&type=script&setup=true&lang=js"

import "./carInfo.vue?vue&type=style&index=0&id=26c5862e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c5862e"]])

export default __exports__